module.exports = __webpack_public_path__ + "img/icon_map_2_5_c.3e62e9b6.png";